import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o e-mail existir, enviámos instruções.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Recuperar palavra-passe" subtitle="Enviaremos instruções para o seu e-mail.">
      {sent ? (
        <div className="rounded-lg border border-border bg-accent/50 p-4 text-sm" data-testid="forgot-sent">
          Verifique o seu e-mail para continuar a recuperação.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5">
            <Label>E-mail</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email" placeholder="nome@empresa.cv" />
          </div>
          <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="forgot-submit">
            {busy ? <CircleNotch className="animate-spin" /> : "Enviar instruções"}
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-muted-foreground">
        <Link to="/login" className="font-medium text-primary hover:underline">Voltar ao início de sessão</Link>
      </p>
    </AuthShell>
  );
}
